export enum CommandButtonErrors {
    RobotNotReady = "RobotNotReady",
    ServerError = "ServerError",
    Unauthorized = "Unauthorized",
}

export enum CommandButtonType {
    ExecuteAction = "EXECUTE_ACTION",
    ListActions = "LIST_ACTIONS",
}

export enum ActionType {
  ListActions = "LIST_ACTIONS",
  ForceSync = "FORCE_SYNC", // attempts to sync up any failed asks
  FullDataSync = "FULL_DATA_SYNC", // attempts to sync up all data, will overwrite local
  OpenServiceConnection = "OPEN_SERVICE_CONNECTION",
  CloseServiceConnection = "CLOSE_SERVICE_CONNECTION",
  Abort = "ABORT",
  ConfirmMaintenance = "CONFIRM_MAINTENANCE",
  Home = "HOME",
  Pause = "PAUSE",
  Resume = "RESUME",
  WakeUp = "WAKEUP",
  Clean = "CLEAN",
  ActivateSchedule = "ACTIVATE_SCHEDULE",
}

export enum DisableReason {
    InStandby = "IN_STANDBY",
    Homing = "HOMING",
    StartingUp = "STARTING_UP",
    AlreadyAtStation = "ALREADY_AT_STATION",
    Paused = "PAUSED",
    HazardActive = "HAZARD_ACTIVE",
    SwUpdateInProgress = "SW_UPDATE_IN_PROGRESS",
}

export enum StatusLightColor {
    Green = "0,200,0",
    Yellow = "250, 210, 0",
    Red = "250, 90, 90",
    Grey = "180, 180, 180",
    Orange = "255, 100, 0",
    White = "255, 255, 255",
    LightBlue = "205, 220, 255"
}